export interface IOddsAssessmentResults {
  institutionsName: string
  programName: string
  programId: number
  programIds: number[]
  probability: keyof typeof EAssessmentResults | null
  onReset: () => void
  onClose: () => void
}

export enum EAssessmentResults {
  high = 'high',
  middle = 'middle',
  low = 'low',
}

export enum EAssessmentColorBg {
  high = 'lime',
  middle = 'yellow',
  low = 'rose50',
}

export enum EAssessmentColorText {
  high = 'emerald',
  middle = 'orange',
  low = 'red',
}

export enum EAssessmentText {
  high = 'высокие',
  middle = 'средние',
  low = 'низкие',
}
